import { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { API, pct } from './api';

const DIMS = [['letter_type', 'By letter type'], ['angle', 'By strategy'], ['bureau', 'By bureau'], ['category', 'By account type'], ['variation', 'By approved variation']];

const Table = ({ title, rows }) => (
  <div className="rounded-xl border border-zinc-800 bg-zinc-900/70 p-3" data-testid={`winrates-${title.replace(/\s+/g, '-').toLowerCase()}`}>
    <p className="text-sm font-bold text-white mb-1">{title}</p>
    {!rows.length ? <p className="text-[11px] text-zinc-500">No results logged yet.</p> : rows.slice(0, 10).map((g) => (
      <p key={g.key} className="flex gap-2 text-xs text-zinc-300">
        <span className="truncate">{g.key}</span>
        <span className="ml-auto shrink-0 text-zinc-500">{g.deleted} del · {g.updated} upd · {g.verified} ver · {g.n} total</span>
        <b className={`w-10 shrink-0 text-right ${g.win_rate >= 0.5 ? 'text-emerald-300' : 'text-rose-300'}`}>{pct(g.win_rate)}</b>
      </p>
    ))}
  </div>
);

// Which letters actually get accounts deleted (Updated counts as half a win).
export default function WinRates() {
  const [s, setS] = useState(null);
  useEffect(() => { axios.get(`${API}/stats`).then((r) => setS(r.data)).catch(() => setS({ error: true })); }, []);
  if (!s) return <Loader2 className="w-5 h-5 animate-spin text-zinc-400" />;
  if (s.error) return <p className="text-sm text-red-400">Could not load win rates.</p>;
  const t = s.total;
  return (
    <div className="space-y-3" data-testid="win-rates">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {[['Letters', t.letters], ['Results logged', t.results], ['Deleted', t.deleted], ['Win rate', pct(t.win_rate)]].map(([k, v]) => (
          <div key={k} className="rounded-lg border border-zinc-800 bg-zinc-900/70 p-2.5" data-testid={`winrates-total-${k.replace(/\s+/g, '-').toLowerCase()}`}>
            <p className="text-[10px] uppercase text-zinc-500">{k}</p><p className="text-lg font-bold text-white">{v}</p>
          </div>
        ))}
      </div>
      <div className="grid gap-3 md:grid-cols-2">{DIMS.map(([k, title]) => <Table key={k} title={title} rows={s[k] || []} />)}</div>
    </div>
  );
}
